<template>
  <div class="passenger-info">
    <p>Passengers</p>
    <div class="row">
      <div class="col-xs-3">
        <img :src="images.adult" alt />
        <span>&nbsp;{{adults.length}} {{adults.length>1?"Adults":"Adult"}}</span>
      </div>
      <div v-if="children.length>0" class="col-xs-3">
        <img :src="images.child" alt />
        <span>&nbsp;{{children.length}} {{children.length>1?"Children":"Child"}}</span>
      </div>
      <div v-if="infants.length>0" class="col-xs-3">
        <img :src="images.infant" alt />
        <span>&nbsp;{{infants.length}} {{infants.length>1?"Infants":"Infant"}}</span>
      </div>
    </div>
  </div>
</template>
<script>
import images from "../../core/images";
export default {
  inheritAttrs: false,
  name: "passenger-info",
  props: {
    children: {
      type: Array,
      default: () => []
    },
    adults: {
      type: Array,
      default: () => []
    },
    infants: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    images: () => images
  }
};
</script>